<template>
  <div class="wrapper">
    <div class="white_box">
      <div class="filter white_box">
        <!-- 搜索框 -->
        <el-input
          class="custom-es"
          size="medium"
          placeholder="请输入员工姓名/证件号码/手机号码"
          v-model="input"
          clearable
        ></el-input>
        <!-- 参保城市下拉框 -->
        <el-select
          class="custom-os"
          v-model="selectedCitys"
          multiple
          filterable
          clearable
          size="medium"
          placeholder="请选择参保城市"
        >
          <el-option
            v-for="item in city_options"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <!-- <p class="font_14_black">薪资月份：</p>
        <el-date-picker class="custom-mc" v-model="month" type="month" placeholder="选择月"></el-date-picker>-->
        <!-- 查询&重置按钮 -->
        <button-a color="#f26828" class="query" @click.native="query()">查询</button-a>
        <button-a color="#08a752" @click.native="reset()">重置</button-a>
     <!-- 标签筛选 -->
      <div class="tags white_box">
        <div class="tag-group">
          <p class="font_14_black">请选择社保参保状态：</p>
          <filter-tag
            :class="{active: socialFilter[1]}"
            @click.native="change('socialFilter', 1)"
            name="已参保"
          />
          <filter-tag
            :class="{active: socialFilter[0]}"
            @click.native="change('socialFilter', 0)"
            name="未参保"
          />
        </div>
        <div class="tag-group">
          <p class="font_14_black">请选择公积金参保状态：</p>
          <filter-tag
            :class="{active: GJJFilter[1]}"
            @click.native="change('GJJFilter', 1)"
            name="已参保"
          />
          <filter-tag
            :class="{active: GJJFilter[0]}"
            @click.native="change('GJJFilter', 0)"
            name="未参保"
          />
          
          <!-- 操作选项 -->
          <!-- <div class="options">
          <div>
            <button-a color="#05b8fe" class>通知设置</button-a>
            <button-a color="#f26828" class>标记已读</button-a>
            <button-a color="#5c74f5" class>标记未读</button-a>
            <button-a color="#fe527b" class>删除</button-a>
          </div>
          </div>-->
        </div>
         <div class="status-group">
          <p class="font_14_black">用工状态：</p>
          <filter-tag
            :class="{ active: status[0] }"
            @click.native="change('status', 0)"
            :name="'在职'"
          />
          <filter-tag
            :class="{ active: status[1] }"
            @click.native="change('status', 1)"
            :name="'离职'"
          />
        </div>
      </div>
      </div>
     
    </div>

    <!-- 标签筛选 -->
    <!-- <div class="tags white_box">
      <div class="tag-group">
        <p class="font_14_black">请选择社保参保状态：</p>
        <filter-tag
          :class="{active: socialFilter[1]}"
          @click.native="change('socialFilter', 1)"
          name="已参保"
        />
        <filter-tag
          :class="{active: socialFilter[0]}"
          @click.native="change('socialFilter', 0)"
          name="未参保"
        />
      </div>
      <div class="tag-group">
        <p class="font_14_black">请选择公积金参保状态：</p>
        <filter-tag
          :class="{active: GJJFilter[1]}"
          @click.native="change('GJJFilter', 1)"
          name="已参保"
        />
        <filter-tag
          :class="{active: GJJFilter[0]}"
          @click.native="change('GJJFilter', 0)"
          name="未参保"
        />
      </div>
    </div>-->
    <!-- 统计 -->
    <!-- <div class="sum-group white_box">
      <sum title="在保人数" :num="totalCount" num_up>
        <img class="icon" src="@/assets/icons/Incumbency@2x.png" alt />
      </sum>
      <sum title="社保缴纳人数" :num="socialCount" num_up>
        <img class="icon" src="@/assets/icons/Payrollthismonth@2x.png" alt />
      </sum>
      <sum title="公积金缴纳人数" :num="gjjCount" num_up>
        <img class="icon" src="@/assets/icons/Providentfundinsurance@2x.png" alt />
      </sum>
      <button-a class="export" color="#ffffff" bgcolor="#85cf96" @click.native="dialog()">导出</button-a>
    </div>-->

    <div class="result white_box">
      <div class="sum-group white_box">
        <sum title="在保人数" :num="totalCount" num_up>
          <img class="icon" src="@/assets/icons/Incumbency@2x.png" alt />
        </sum>
        <sum title="社保缴纳人数" :num="socialCount" num_up>
          <img class="icon" src="@/assets/icons/Payrollthismonth@2x.png" alt />
        </sum>
        <sum title="公积金缴纳人数" :num="gjjCount" num_up>
          <img class="icon" src="@/assets/icons/Providentfundinsurance@2x.png" alt />
        </sum>
        <button-a class="export" color="#ffffff" bgcolor="#85cf96" @click.native="getExcel()" :loading="exportLoading">{{ exportLoading ? '正在导出中...' : '导出' }}</button-a>
      </div>
      <!-- 表格
        ref="multipleTable" 引用名
        :data="tableData" 绑定数据
        :header-row-style="headerRowStyle" 表头样式
        :row-style="rowStyle" 行样式
      -->
      <div v-loading="loading" element-loading-text="加载中..." class="table-wrapper">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        :header-row-style="{height: translateWidth(68)+'px', fongSize: '14px', color: '#000', backgroundColor: '#fafbff'}"
        :header-cell-style="{backgroundColor: 'transparent'}"
        :row-style="{height: translateWidth(60)+'px', backgroundColor: '#fff'}"
        style="width: 100%;font-size: 14px;color: #707070;border: 1px solid #e5e5e5;border-radius: 6px"
        @selection-change="handleSelectionChange"
        @row-click="handleRowClick"
        @row-dblclick="handleRowDblclick"
        @row-mousedown="handleRowMousedown"
        @row-mousemove="handleRowMousemove"
        @row-mouseup="handleRowMouseup"
      >
        <!-- 占位列 -->
        <el-table-column :width="tableWidth[0] | translateWidth"></el-table-column>
        <!-- 多选框 -->
        <!-- <el-table-column type="selection" width="66"></el-table-column> -->
        <el-table-column type="index" label="序号" :width="tableWidth[1] | translateWidth"></el-table-column>
        <el-table-column prop="customerName" label="所属企业" :width="translateWidth(270)" show-overflow-tooltip></el-table-column>
        <el-table-column prop="employeeName" label="员工姓名" :width="tableWidth[3] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="idCard" label="证件号码" :width="tableWidth[4] | translateWidth" show-overflow-tooltip></el-table-column>
           <el-table-column prop="mobile" label="手机号" :width="tableWidth[3] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="workStatus" label="用工状态" :width="tableWidth[5] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column prop="joinCity" label="参保城市" :width="tableWidth[6] | translateWidth" show-overflow-tooltip></el-table-column>
        <el-table-column label="社保参保状态" :width="tableWidth[7] | translateWidth" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.isJoinSocial?"已参保":"未参保"}}</template>
        </el-table-column>
        <el-table-column label="公积金参保状态" :width="tableWidth[8] | translateWidth" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.isJoinGjj?"已参保":"未参保"}}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="font_14_orange pointer view" @click="view(scope.row)">查看</span>
            <!-- <span class="font_14_orange pointer detail" @click="view(scope)">通知详情</span>
            <span class="font_14_gray pointer" @click="view(scope)">业务查看</span>-->
          </template>
        </el-table-column>
      </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, sizes, jumper, ->, slot"
        :total="total"
        :pager-count="5"
      ></el-pagination>
    </div>
    <!-- 导出对话框 -->
    <el-dialog title :visible.sync="mask" width="31%" center>
      <h3 class="export-title font_16_black">社保详情导出</h3>
      <div class="export-item">
        <p class="export-item-name font_14_black">所属企业</p>
        <el-select
          class="custom-os"
          v-model="selectedValue2"
          @change="exportCustomerChange"
          multiple
          filterable
          clearable
          default-first-option
          size="medium"
          placeholder="请选择所属企业或输入关键字搜索"
        >
          <el-option
            v-for="item in options"
            :key="item.key"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </div>
      <div class="export-item">
        <p class="export-item-name font_14_black">参保城市</p>
        <el-select
          class="custom-os"
          v-model="selectedCitys"
          multiple
          filterable
          clearable
          default-first-option
          size="medium"
          placeholder="请选择参保城市或输入关键字搜索"
        >
          <el-option
            v-for="item in city_options"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <!-- <el-input class="custom-es" size="medium" placeholder="请输入参保城市" v-model="city" clearable></el-input> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="export_btn">
          <button-a
            padding="10px 128px"
            color="#fff"
            bgcolor="#f26828"
            @click.native="getExcel()"
          >导出</button-a>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Get, Download } from "@/js/http.js";
import { Filter, translateWidth } from "@/js/tool.js";

export default {
  name: "SocialSecurity",
  components: {},
  props: {},
  data() {
    return {
      tableWidth: [35, 80, 270, 136, 298, 136, 134, 156, 170],
      mask: false, // 遮罩
      // 搜索与筛选
      options: [
        // 组织搜索框
      ],
     status: {
        // 用工状态
        0: true, // 在职
        1: true // 离职
      }, // 用工状态
      selectedValue: "", // 选择的组织id
      selectedValue2: [], // 导出选择的组织id
      input: "", // 员工搜索输入
      selectedCity: [], // 参保城市
      month: "", // 月份选择
      socialFilter: {
        // 社保状态
        0: true,
        1: true
      },
      GJJFilter: {
        //  公积金状态
        0: true,
        1: true
      },

      // 统计相关
      totalCount: 0, // 在保人数
      socialCount: 0, // 社保缴纳人数
      gjjCount: 0, // 公积金缴纳人数
      onTheJob: 0, // 在职数
      quitTheJob: 0, // 离职数

      // 表格相关
      page: 1, // 当前页码
      size: 10, // 每页条数
      total: 0, // 总条数
      tableData: [], // 表格数据
      loading: false, // 数据加载状态
      multipleSelection: [], // 表格行选择
      activeNames: [], // 展开的折叠面板

      // 导出相关
      city_options: [],
      selectedCitys: [],
      exportLoading: false, // 导出加载状态
      
      // 交互相关
      clickTimer: null, // 单击定时器
      isDragging: false, // 是否正在拖动
      isDoubleClick: false // 是否双击
    };
  },
  watch: {},
  computed: {
    // 请求的数据的跳过条数
    SkipCount() {
      return (this.page - 1) * this.size;
    },
    socialStatus() {
      let status = "";
      if (this.socialFilter[0]) {
        status = 0;
      }
      if (this.socialFilter[1]) {
        status = 1;
      }
      if (this.socialFilter[0] && this.socialFilter[1]) {
        status = -1;
      }
      return status;
    },
    GJJStatus() {
      let status = "";
      if (this.GJJFilter[0]) {
        status = 0;
      }
      if (this.GJJFilter[1]) {
        status = 1;
      }
      if (this.GJJFilter[0] && this.GJJFilter[1]) {
        status = -1;
      }
      return status;
    }
  },
  methods: {
    // 对话框关闭回调
    handleClose(done) {
      done();
    },
    selectChange() {},
    // 点击筛选标签 dataName: String，key: Number/String
    change(dataName, key) {
      let ischanged = Filter.call(this, dataName, key);
      if (ischanged) {
        this.page = 1;
        this.getData();
      }
    },
    // 查询
    query() {
      this.page = 1;
      this.getData();
    },
    // 重置
    reset() {
      this.selectedValue = "";
      this.input = "";
      this.selectedCitys = [];
      // 恢复社保参保状态为全选
      this.socialFilter = {
        0: true,
        1: true
      };
      // 恢复公积金参保状态为全选
      this.GJJFilter = {
        0: true,
        1: true
      };
      // 恢复用工状态为全选
      this.status = {
        0: true,
        1: true
      };
      // 刷新数据
      this.getData();
    },
    // 表格项选中
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 表格项选择
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 处理行点击（支持双击取消跳转、拖动选中不跳转）
    handleRowClick(item) {
      if (this.isDragging || this.isDoubleClick) {
        this.isDoubleClick = false;
        return;
      }
      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
      }
      this.clickTimer = setTimeout(() => {
        this.$router.push({
          name: "SocialSecurityItem",
          params: { id: item.detailId || item.employeeId }
        });
        this.clickTimer = null;
      }, 300);
    },
    // 处理双击
    handleRowDblclick(item) {
      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
        this.clickTimer = null;
      }
      this.isDoubleClick = true;
      this.copyRowData(item);
    },
    // 处理鼠标按下
    handleRowMousedown() {
      this.isDragging = false;
    },
    // 处理鼠标移动
    handleRowMousemove() {
      this.isDragging = true;
    },
    // 处理鼠标释放
    handleRowMouseup() {
      setTimeout(() => {
        this.isDragging = false;
      }, 100);
    },
    // 复制行数据文本
    copyRowData(item) {
      const rowText = `所属企业: ${item.customerName || ''}\n员工姓名: ${item.employeeName || ''}\n证件号码: ${item.idCard || ''}\n手机号: ${item.mobile || ''}\n用工状态: ${item.workStatus || ''}\n参保城市: ${item.joinCity || ''}\n社保参保状态: ${item.isJoinSocial ? '已参保' : '未参保'}\n公积金参保状态: ${item.isJoinGjj ? '已参保' : '未参保'}`;
      
      navigator.clipboard.writeText(rowText).then(() => {
        this.$message.success('已复制整行数据');
      }).catch(() => {
        const textarea = document.createElement('textarea');
        textarea.value = rowText;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.$message.success('已复制整行数据');
      });
    },
    // 查看（保留原方法，用于操作列的查看按钮）
    view(item) {
      this.$router.push({
        name: "SocialSecurityItem",
        params: { id: item.detailId || item.employeeId }
      });
    },
    // 每页条数选择
    handleSizeChange(v) {
      this.size = v;
    },
    // 页码选择
    handleCurrentChange(v) {
      this.page = v;
      this.getData();
    },
    // 折叠面板
    handleChange() {
    },
    // 获取组织数据
    getOptions() {
      Get("api/v1/customers/selectors").then(({ data }) => {
        this.options = data;
      });
    },
   getCitys() {
  Get("api/v1/social-securities/cities").then(({ data }) => {
    // 假设 data 是你给出的数组格式
    this.city_options = data.map(item => item.city);
  });
},
    // 获取表格数据
    getData() {
      this.loading = true
      let Status = '';
      if (this.status[0] && this.status[1]) {
        Status = '';
      } else if (this.status[0]) {
        Status = '在职';
      } else if (this.status[1]) {
        Status = '离职';
      }
      // 处理城市选择，将数组转换为字符串
      const city = Array.isArray(this.selectedCitys) ? this.selectedCitys.join(',') : this.selectedCitys;
      Get("api/v1/social-securities", {
        Citys: city, // 参保/公积金城市
        Keyword: this.input, // 员工姓名/证件号码
        SocialStatus: this.socialStatus, // 社保参保状态，为""时报400错误
        GjjStatus: this.GJJStatus, // 公积金参保状态
        WorkStatus: Status, // 用工状态
        MaxResultCount: this.size, // 最大返回条数
        SkipCount: this.SkipCount // 忽略条数
      }).then(res => {
        this.total = res.data.totalCount;
        this.tableData = res.data.items;
        // 解析统计数据 msg: "Insured:1,SoInsured:1,GjjInsured:1"
        if (res.msg) {
          const stats = res.msg.split(',').reduce((acc, item) => {
            const [key, value] = item.split(':');
            acc[key] = parseInt(value) || 0;
            return acc;
          }, {});
          this.totalCount = stats.Insured || 0; // 在保人数
          this.socialCount = stats.SoInsured || 0; // 社保缴纳人数
          this.gjjCount = stats.GjjInsured || 0; // 公积金缴纳人数
        }
        
        this.loading = false
      }).catch(() => {
        this.loading = false
      });
    },
    // 显示对话框
    dialog() {
      // 检查是否全选状态
      let isAllSocialFilter = this.socialFilter[0] && this.socialFilter[1]
      let isAllGJJFilter = this.GJJFilter[0] && this.GJJFilter[1]
      let isAllStatus = this.status[0] && this.status[1]
      let isAllSelected = isAllSocialFilter && isAllGJJFilter && isAllStatus
      
      // 检查城市选择是否为空
      let isCityEmpty = !this.selectedCitys || (Array.isArray(this.selectedCitys) && this.selectedCitys.length === 0);
      
      // 当所有筛选条件都全选时，需要输入其他查询条件
      if (isAllSelected && !this.input && isCityEmpty) {
        this.$message.warning('请至少输入一个查询条件或选择一个筛选条件');
        return;
      }
      
      this.mask = !this.mask;
    },
    exportCustomerChange() {
      // this.getCity();
    },
    // 导出excel
    getExcel() {
      // 检查是否全选状态
      let isAllSocialFilter = this.socialFilter[0] && this.socialFilter[1]
      let isAllGJJFilter = this.GJJFilter[0] && this.GJJFilter[1]
      let isAllStatus = this.status[0] && this.status[1]
      let isAllSelected = isAllSocialFilter && isAllGJJFilter && isAllStatus
      
      // 检查城市选择是否为空
      let isCityEmpty = !this.selectedCitys || (Array.isArray(this.selectedCitys) && this.selectedCitys.length === 0);
      
      // 当所有筛选条件都全选时，需要输入其他查询条件
      if (isAllSelected && !this.input && isCityEmpty) {
        this.$message.warning('请至少输入一个查询条件或选择一个筛选条件');
        return;
      }
      
      let Status = '';
      if (this.status[0] && this.status[1]) {
        Status = '';
      } else if (this.status[0]) {
        Status = '在职';
      } else if (this.status[1]) {
        Status = '离职';
      }
      
      // 处理城市选择，将数组转换为字符串
     const city = Array.isArray(this.selectedCitys) ? this.selectedCitys.join(',') : this.selectedCitys;
      
      // 获取当前日期
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const dateStr = `${year}${month}${day}`;
      
      // 获取客户全称
      const customerName = localStorage.getItem('tenant_name') || localStorage.getItem('companyName') || '客户';
      
      // 设置导出加载状态
      this.exportLoading = true;
      
      Download(
        'api/v1/social-securities/excel',
        {
          version: "1",
          Citys: city,
          Keyword: this.input,
          SocialStatus: this.socialStatus,
          GjjStatus: this.GJJStatus,
          WorkStatus: Status
        },
        `${customerName}-员工社保-${dateStr}.xlsx`
      )
      .then(() => {
        // 导出成功
        this.exportLoading = false;
      })
      .catch(err => {
        // 导出失败
        this.exportLoading = false;
        this.$message.error('导出失败，请稍后重试');
        console.error('导出失败:', err);
      });
    },
    translateWidth(num) {
      return translateWidth(num)
    },
    // 绑定窗口缩放事件
    ifResize() {
      window.addEventListener("resize", this.resize);
    },
    resize() {
      this.tableWidth = JSON.parse(JSON.stringify(this.tableWidth))
    }
  },
  created() {},
  mounted() {
    this.getOptions();
    this.getData();
    this.getCitys();
  },
  activated() {
    this.ifResize();
  },
  deactivated() {
    // 解除事件
    window.removeEventListener('resize', this.resize)
  },
  beforeDestroy() {
  }
};
</script>

<style lang="scss" scoped>
// 布局样式
.wrapper {
  padding: 150px 32px 24px;
  > div {
    margin-bottom: 32px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .filter {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
    padding: 22px 48px;
    position: fixed;
    top: 70px;
    left: 11.6vw;
    right: 0;
    z-index: 100;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    max-width: calc(100% - 11.6vw);
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    .custom-es {
      min-width: 256px;
      margin-right: 0;
    }
    .custom-os {
      min-width: 256px;
      margin-left: 0;
      margin-right: 0;
    }
    .query {
      margin-right: 0;
    }
  }
  .tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 24px;
    .tag-group {
      display: flex;
      align-items: center;
      margin-bottom: 0;
    }
    .options {
      flex: 1;
      div {
        width: 100%;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  .sum-group {
    display: flex;
    padding: 24px 0 24px;
    align-items: center;
    .sum {
      width: 240px;
      &:last-of-type {
        flex: 1;
      }
    }
  }
  .result {
    padding: 30px 48px 48px;
  }
}
/** 
  补充样式
*/
// 筛选标签
.filter-tag {
  margin-left: 6px;
  margin-right: 24px;
}
// 用工状态标签组
.status-group {
  display: flex;
  align-items: center;
  gap: 8px;

  .font_14_black {
    margin: 0;
  }
  .filter-tag {
    margin-left: 6px;
    margin-right: 24px;
  }
}
// 查询按钮
.query {
  margin-right: 32px;
}
// 导出按钮
.export {
  margin-right: 50px;
}
// 查看按钮
.view {
  margin-right: 18px;
}
// 通知详情按钮
.detail {
  margin-right: 18px;
}

// 属性面板
.infomation {
  display: flex;
  align-items: center;
  padding: 30px 84px;
}
.user_picture {
  margin-right: 64px;
}
// 键值对
.key-value {
  display: flex;
  justify-content: center;
  align-self: stretch;
  margin-right: 150px;
  &:last-child {
    margin-right: 0;
  }
  .key {
    margin-right: 50px;
    p {
      text-align: right;
    }
  }
  p {
    margin-bottom: 32px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}

// 小标签
.tag {
  margin-left: 16px;
}

// 折叠面板
.fold {
  overflow: hidden;
  padding: 32px 64px;
  .el-collapse {
    border: none;
    .row {
      padding-top: 32px;
      padding-left: 50px;
    }
    ::v-deep .el-collapse-item__header {
      border: none;
      img {
        transition: all 0.6s ease;
      }
    }
    ::v-deep .el-collapse-item__wrap {
      border: none;
    }
    ::v-deep .el-collapse-item__content {
      padding-bottom: 0;
    }
    ::v-deep .el-collapse-item.is-active {
      img {
        transform: rotate(180deg);
        transition: all 0.6s ease;
      }
    }
    ::v-deep .el-collapse-item__arrow {
      display: none;
    }
  }
  .fold_title {
    display: flex;
    align-items: center;
    // padding-left: 64px;
    .money {
      width: 236px;
      height: 46px;
      margin-left: 40px;
      margin-right: 58px;
      line-height: 46px;
      text-align: center;
      background-color: #eff2fe;
      border-radius: 8px;
    }
    .fold_btn {
      display: flex;
      align-items: center;
    }
  }
}

// 弹出框
.export-title {
  margin-bottom: 46px;
  text-align: center;
  font-weight: bold;
}
::v-deep .el-dialog {
  border-radius: 8px;
  .el-dialog__footer {
    padding-bottom: 65px;
  }
  .export-item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 32px;
    &:last-child {
      margin-bottom: 0;
    }
    .el-select {
      margin-left: 0;
      margin-right: 0;
    }
    .el-input {
      margin-left: 0;
      margin-right: 0;
    }
    .export-item-name {
      margin-right: 24px;
      font-weight: bold;
    }
    .export_btn {
      padding-bottom: 45px;
    }
  }
}
</style>